import {Action} from "redux-actions";
import Meta from "../_data/models/Meta";
import {    
    clearStyle,   
    didReceiveStyles,    
    didReceiveStyle,    
    clearStyles,
    requestFailed,
    requestStarted,
    requestSucceeded,    
    saveScrollpos
} from "./actions";
import {Map, OrderedMap} from "immutable";

import {
    requestComments,
    receiveComments,
    clearComments,
} from "../comment/actions";
import Style from "../_data/models/Style";
import Comment from "../_data/models/Comment";
import commentsReducer from "../comment/reducers";
import {combineReducers} from "redux";

//reducers
const myStylesReducer = combineReducers({
    ids: items,
    meta,
    loading,
    errors,
    scrollPosition
});

const styleReducer = combineReducers({   
    id: item, 
    loading,
    comments: commentsReducer    
});

export {myStylesReducer};
export default styleReducer;

function errors(state: string[] = [], action: Action<ApiRequestAction>) {
    switch (action.type){
        case requestStarted.toString():
            return [];
        case requestSucceeded.toString():
            return [];
        case requestFailed.toString():
            return action.payload.requestErrors
    }

    return state;
}

function item(state: number = null, action: Action<StyleAction>) {
    switch (action.type) {
        case clearStyles.toString():
            return null;
        case didReceiveStyle.toString():
            return action.payload.id;        
    }
    return state;
}


function items(state: number[] = [], action: Action<StyleAction>) {
    switch (action.type) {
        case clearStyles.toString():
            return [];
        case didReceiveStyles.toString():            
            return [...state, ...action.payload.ids];        
    }
    return state;
}

function meta(state: Meta = null, action: Action<StyleAction>) {
    switch (action.type) {
        case didReceiveStyles.toString():
            return action.payload.meta;
        case clearStyles.toString():
            return null;
    }

    return state;
}

function loading(state: boolean = false, action: Action<StyleAction>) {
    switch (action.type) {    
        case requestStarted.toString():
        case requestComments.toString():
            return true;
        case requestSucceeded.toString():
            return false;
    }
    return state;
}

function scrollPosition(state: number = 0, action: Action<StyleAction>) {   
    switch(action.type) {     
        case saveScrollpos.toString():        
            return action.payload;                
    }

    return state;
}

//interfaces
interface StyleAction {        
    id: number;
    ids: number[];
    meta: Meta;
    scrollPosition:number;    
}


// WEBPACK FOOTER //
// ./app/client/style/reducers.ts